/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are percentages calculated for me?`)
};

const es_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Los porcentajes se calculan automáticamente?`)
};

const de_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Prozentsätze für mich berechnet?`)
};

const nl_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden percentages voor mij berekend?`)
};

const fr_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les pourcentages sont-ils calculés pour moi ?`)
};

const it_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le percentuali vengono calcolate per me?`)
};

const pt_br2_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os percentuais são calculados para mim?`)
};

const pt_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As percentagens são calculadas por mim?`)
};

const ja_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセンテージは自動計算されますか？`)
};

const zh_pie_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比是自动计算的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_faq_q2", locale)
	if (locale === "en") return en_pie_faq_q2(inputs)
	if (locale === "es") return es_pie_faq_q2(inputs)
	if (locale === "de") return de_pie_faq_q2(inputs)
	if (locale === "nl") return nl_pie_faq_q2(inputs)
	if (locale === "fr") return fr_pie_faq_q2(inputs)
	if (locale === "it") return it_pie_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_pie_faq_q2(inputs)
	if (locale === "pt") return pt_pie_faq_q2(inputs)
	if (locale === "ja") return ja_pie_faq_q2(inputs)
	return zh_pie_faq_q2(inputs)
};